import {useEffect, useState} from "react";
import {useDashboardContext} from "../dashboardContextProvider";
import {DashboardListForloebModel} from "./models/DashboardListForloebModel";
import {DashboardListUkoModel} from "./models/DashboardListForloebUkoModel";

const useDashboardList = () => {
    const [forloebList, setForloebList] = useState<DashboardListForloebModel[]>([]);
    const [forloebListUko, setForloebListUko] = useState<DashboardListUkoModel[]>([]);
    const {state} = useDashboardContext()

    useEffect(() => {
        setForloebList(state.dashboardListData);
        setForloebListUko(state.dashboardListUkoData);
    }, [state.dashboardListData, state.dashboardListUkoData])

    return {
        forloebList: forloebList,
        forloebListUko: forloebListUko,
        isLoading: state.dashboardListDataIsLoading,
    }
}
export default useDashboardList;
